import ApiClient from 'apiClients';

class RecaptchaClient extends ApiClient {
  constructor() {
    super(`/api/recaptcha/`);
  }
}

export default new RecaptchaClient();
